import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

export const TeamFiltersHeader = () => {
    const { translate } = useTranslate();

    return (
        <Stack
            gap="4px"
            padding="20px 24px"
            data-automation="team-filters-header"
        >
            <Text
                fontVariant="h5"
                color={colorsPalettes.carbon[500]}
            >
                {translate("si.management.teams.detail.filters.title")}
            </Text>
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[400]}
            >
                {translate("si.management.teams.detail.filters.overlay.subtitle")}
            </Text>
        </Stack>
    );
};
